import { FONTS } from './_variables'

export const rem = (size: number) => `${size / FONTS.base_font_size}rem`
